import {useRef, useEffect, useState} from "react";
import { Row, Col, Button } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import ProductCard from "./ProductCard";
import ProductCardNew from "./ProductCardNew";
import UIRecommendationHeaderNew from "./UIRecommendationHeaderNew";

export default function ProductSectionNew({
  title,
  subtitle,
  iconType,
  backgroundColor,
  fontColor,
  products =[
    {
      "asin": "B00CXXKE8A",
      "capacity_per_item": 32,
      "capacity_per_pack": 64,
      "id": "af7c6ba344ef4f07a2c2ae4392739bfd",
      "image": "https://m.media-amazon.com/images/I/81h0F0ivPiL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 2,
      "key": "B00CXXKE8A",
      "link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/",
      "price": 18.42,
      "rating": 4.6,
      "reviews": 12532,
      "store": "Amazon",
      "title": "Community Coffee Breakfast Blend Ground Coffee, Medium Roast, 32 Ounce (Pack of 2)",
      "unit": "oz",
      "unit_price": 0.2878125,
      "amazon_price": 18.42,
      "walmart_price": 19.98,
      "walmart_link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "amazon_link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/",
      "amazon_unit_price": 0.2878125,
      "walmart_unit_price": 0.3124375,
      "target_price": 15.00,
      "target_unit_price": 0.234375,
      "target_link": "https://www.target.com/p/community-coffee-breakfast-blend-ground-coffee-medium-roast-32oz/-/A-14723409",
    },
    {
      "asin": "B07335VMVJ",
      "capacity_per_item": 32,
      "capacity_per_pack": 32,
      "id": "ff384938c5994934ace2392f35886915",
      "image": "https://m.media-amazon.com/images/I/61HlOwfvgNL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B07335VMVJ",
      "link": "https://www.amazon.com/Camerons-Coffee-Roasted-Ground-Ounce/dp/B07335VMVJ/",
      "price": 10.98,
      "rating": 4.5,
      "reviews": 9275,
      "store": "Amazon",
      "title": "Cameron's Coffee Roasted Ground Coffee Bag, Breakfast Blend, 32 Ounce",
      "unit": "oz",
      "unit_price": 0.343125,
      "amazon_price": 10.98,
      "walmart_price": 12.98,
      "walmart_link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "amazon_link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/"
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "dd0d4c4a7ebc43c0ac91d18ffe509cee",
      "image": "https://i5.walmartimages.com/seo/Seattle-s-Best-Coffee-Breakfast-Blend-Medium-Roast-Ground-Coffee-100-Arabica-12-oz_6aaca7c1-1adf-49f1-8f71-67b2ba2eb113.7b5748860fadc4c3ff3114ebccbe42c9.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "4ILMS3RHIZ9U",
      "link": "https://www.walmart.com/ip/Seattle-s-Best-Coffee-Breakfast-Blend-Medium-Roast-Ground-Coffee-100-Arabica-12-oz/34557752?classType=VARIANT",
      "price": 4.48,
      "rating": 4.4,
      "reviews": 5252,
      "store": "Walmart",
      "title": "Seattles Best Coffee, Breakfast Blend, Medium Roast, Ground Coffee, 100% Arabica, 12 oz",
      "unit": "oz",
      "unit_price": 0.37333333333333335,
      "amazon_price": 5.43,
      "walmart_price": 4.48,
      "walmart_link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "amazon_link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/"
    },
    {
      "asin": "B0BBSV6WFX",
      "capacity_per_item": 32,
      "capacity_per_pack": 32,
      "id": "b6411b1a9d2f47c4bd4761f49a9dfb00",
      "image": "https://m.media-amazon.com/images/I/81Zremcy2zL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B0BBSV6WFX",
      "link": "https://www.amazon.com/Eight-OClock-Coffee-Original-Certified/dp/B0BBSV6WFX/",
      "price": 13.31,
      "rating": 4.6,
      "reviews": 22895,
      "store": "Amazon",
      "title": "Eight O'Clock Coffee The Original Ground Coffee, Medium Roast, 32 Ounce (Pack of 1) - Sweet, Fruity, Well Balanced",
      "unit": "oz",
      "unit_price": 0.4159375,
      "amazon_price": 13.31,
      "walmart_price": 14.98,
      "walmart_link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "amazon_link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/"
    },
    {
      "asin": "B0CXZ3HLYS",
      "capacity_per_item": 28.4,
      "capacity_per_pack": 28.4,
      "id": "9f28735ba9ce489ab8922d7009bdcf75",
      "image": "https://m.media-amazon.com/images/I/71tVYMZlkpL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B0CXZ3HLYS",
      "link": "https://www.amazon.com/Maxwell-28-4oz-Ground-Coffee-Medium/dp/B0CXZ3HLYS/",
      "price": 11.99,
      "rating": 4.7,
      "reviews": 8778,
      "store": "Amazon",
      "title": "Maxwell House 28.4oz Ground Coffee Medium Wake Up Roast",
      "unit": "oz",
      "unit_price": 0.42218309859154934,
      "amazon_price": 11.99,
      "walmart_price": 13.98,
      "walmart_link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "amazon_link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/"
    },
    {
      "capacity_per_item": 40.3,
      "capacity_per_pack": 40.3,
      "id": "253e3d91c8dd4d2faea28345036bab40",
      "image": "https://i5.walmartimages.com/seo/Folgers-Classic-Roast-Ground-Coffee-Medium-Roast-40-3-Oz-Canister_d32f1993-c51f-4e64-90db-dbcfda8713eb.7c89870918c4f2e6f79a492693cac992.jpeg",
      "is_large_size": true,
      "items_per_pack": 1,
      "key": "5AGYG6IIND2V",
      "link": "https://www.walmart.com/ip/Folgers-Classic-Roast-Ground-Coffee-Medium-Roast-40-3-Oz-Canister/971362035?classType=VARIANT&athbdg=L1300",
      "price": 17.17,
      "rating": 4.6,
      "reviews": 9821,
      "store": "Walmart",
      "title": "Folgers Classic Roast Ground Coffee, Medium Roast, 40.3 oz Canister",
      "unit": "oz",
      "unit_price": 0.42605459057071965,
      "amazon_price": 11.99,
      "walmart_price": 13.98,
      "walmart_link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "amazon_link": "https://www.amazon.com/Community-Coffee-Breakfast-Premium-Arabica/dp/B00CXXKE8A/"
    },
    {
      "asin": "B004DPF6TS",
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "011f38cd245a4c05a6bdbc88af841c51",
      "image": "https://m.media-amazon.com/images/I/61PmjB-QpKL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B004DPF6TS",
      "link": "https://www.amazon.com/New-England-Coffee-Breakfast-Blend/dp/B004DPF6TS/",
      "price": 5.43,
      "rating": 4.5,
      "reviews": 27380,
      "store": "Amazon",
      "title": "New England Coffee Breakfast Blend Medium Roast Ground Coffee, 12oz Bag (Pack of 1)",
      "unit": "oz",
      "unit_price": 0.45249999999999996,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "capacity_per_item": 48,
      "capacity_per_pack": 48,
      "id": "001e0fefbb58495297dd7b0f0408725a",
      "image": "https://i5.walmartimages.com/seo/Maxwell-House-Medium-Roast-Original-Roast-Ground-Coffee-Club-Pack-48-oz-Canister_45575b10-21a0-4d87-8a69-88c73f75badc.203a5ec5f3c1dcdd33d8320205e729b0.jpeg",
      "is_large_size": true,
      "items_per_pack": 1,
      "key": "4KHRMFIIV1RO",
      "link": "https://www.walmart.com/ip/Maxwell-House-Medium-Roast-Original-Roast-Ground-Coffee-Club-Pack-48-oz-Canister/371297790?classType=REGULAR",
      "price": 21.85,
      "rating": 4.8,
      "reviews": 6465,
      "store": "Walmart",
      "title": "Maxwell House Medium Roast Original Roast Ground Coffee Club Pack, 48 oz. Canister",
      "unit": "oz",
      "unit_price": 0.4552083333333334,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B011VQ8TKY",
      "capacity_per_item": 30.5,
      "capacity_per_pack": 30.5,
      "id": "ad42eaef69a747a880e5a9c62bdf8094",
      "image": "https://m.media-amazon.com/images/I/81Ym9vsJ9iL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B011VQ8TKY",
      "link": "https://www.amazon.com/Chock-Full-Nuts-10071038130004-Coffee/dp/B011VQ8TKY/",
      "price": 14.24,
      "rating": 4.7,
      "reviews": 7436,
      "store": "Amazon",
      "title": "Chock Full o\u2019Nuts Original Roast, Medium Roast Ground Coffee \u2013 Gourmet Coffee Beans \u2013 Smooth, Full-Bodied and Rich Coffee (30.5 Oz. Can)",
      "unit": "oz",
      "unit_price": 0.4668852459016394,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B0CXYYWL6G",
      "capacity_per_item": 27.5,
      "capacity_per_pack": 27.5,
      "id": "00c6429f6138436781356335d257293a",
      "image": "https://m.media-amazon.com/images/I/71U3wxOoQHL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B0CXYYWL6G",
      "link": "https://www.amazon.com/Maxwell-27-5oz-Ground-Coffee-Original/dp/B0CXYYWL6G/",
      "price": 13.32,
      "rating": 4.7,
      "reviews": 20669,
      "store": "Amazon",
      "title": "Maxwell House 27.5oz Ground Coffee Medium Original Roast",
      "unit": "oz",
      "unit_price": 0.4843636363636364,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "b8828640344e4aedbfde6166640500e4",
      "image": "https://i5.walmartimages.com/seo/McCafe-Premium-Roast-Medium-Roast-Ground-Coffee-12-oz_392e362a-2147-477c-b9eb-f218a6321cd2.ff40f84f933842e2ff0ba9d86c466ab6.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "5G8D1MJYO0CK",
      "link": "https://www.walmart.com/ip/McCafe-Premium-Roast-Medium-Roast-Ground-Coffee-12-oz/42286893?classType=VARIANT&athbdg=L1600",
      "price": 8.97,
      "rating": 4.7,
      "reviews": 4561,
      "store": "Walmart",
      "title": "McCafe Premium Roast, Medium Roast, Ground Coffee, 12 oz",
      "unit": "oz",
      "unit_price": 0.7475,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B0CXZ5NWRV",
      "capacity_per_item": 27.9,
      "capacity_per_pack": 27.9,
      "id": "6004154ff3fd405fb8e0ce7785c8e056",
      "image": "https://m.media-amazon.com/images/I/81kleiOP4nL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B0CXZ5NWRV",
      "link": "https://www.amazon.com/Yuban-Traditional-Medium-Ground-Coffee/dp/B0CXZ5NWRV/",
      "price": 13.99,
      "rating": 4.7,
      "reviews": 243,
      "store": "Amazon",
      "title": "Yuban Traditional Medium Roast Ground Coffee (27.9 oz)",
      "unit": "oz",
      "unit_price": 0.5014336917562724,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B09369PSV9",
      "capacity_per_item": 18,
      "capacity_per_pack": 18,
      "id": "ff219d5c73614866aa82390ee6d9252f",
      "image": "https://m.media-amazon.com/images/I/71mtK02rWkL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B09369PSV9",
      "link": "https://www.amazon.com/Starbucks-Medium-Roast-Ground-Coffee/dp/B09369PSV9/",
      "price": 9.63,
      "rating": 4.6,
      "reviews": 30966,
      "store": "Amazon",
      "title": "Starbucks Ground Coffee, Medium Roast Coffee, House Blend, 100% Arabica, 1 bag (18 oz)",
      "unit": "oz",
      "unit_price": 0.535,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B072MQ5BRX",
      "capacity_per_item": 32,
      "capacity_per_pack": 32,
      "id": "f3960a14a443444fa322307a0c8e99db",
      "image": "https://m.media-amazon.com/images/I/71AkGIlaV7L._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B072MQ5BRX",
      "link": "https://www.amazon.com/AmazonFresh-Colombia-Ground-Coffee-Medium/dp/B072MQ5BRX/",
      "price": 17.31,
      "rating": 4.3,
      "reviews": 20326,
      "store": "Amazon",
      "title": "Amazon Fresh, Colombia Ground Coffee, Medium Roast, 32 Oz",
      "unit": "oz",
      "unit_price": 0.5409375,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "ed34359e23924d05ba7e726c1f5f5907",
      "image": "https://i5.walmartimages.com/seo/Seattle-s-Best-Coffee-Portside-Medium-Roast-Ground-Coffee-100-Arabica-12-oz_b2875369-8aa2-44d0-afe5-9433833eb4c9.b6fa061f0d04dccff41f3ed541eedcb5.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "3U41N8HFZWA1",
      "link": "https://www.walmart.com/ip/Seattle-s-Best-Coffee-Portside-Medium-Roast-Ground-Coffee-100-Arabica-12-oz/10294599?classType=VARIANT",
      "price": 7.47,
      "rating": 4.4,
      "reviews": 5252,
      "store": "Walmart",
      "title": "Seattles Best Coffee, Portside, Medium Roast, Ground Coffee, 100% Arabica, 12 oz",
      "unit": "oz",
      "unit_price": 0.6224999999999999,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B00H3TJXRW",
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "c8b6998e684d44dcaa01c791c71f9ceb",
      "image": "https://m.media-amazon.com/images/I/81ufwizf87S._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B00H3TJXRW",
      "link": "https://www.amazon.com/Green-Mountain-Coffee-Roasters-Nantucket/dp/B00H3TJXRW/",
      "price": 7.48,
      "rating": 4.6,
      "reviews": 9299,
      "store": "Amazon",
      "title": "Green Mountain Coffee Roasters, Nantucket Blend, Fair Trade Certified, Ground Coffee, Medium Roast, Bagged 12oz.",
      "unit": "oz",
      "unit_price": 0.6233333333333334,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B01FTE4NEU",
      "capacity_per_item": 20,
      "capacity_per_pack": 20,
      "id": "ef63b75313354fe193661951f93cceff",
      "image": "https://m.media-amazon.com/images/I/61CJn+sthkL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B01FTE4NEU",
      "link": "https://www.amazon.com/Caribou-Coffee-Balanced-Indonesia-Sustainable/dp/B01FTE4NEU/",
      "price": 13.12,
      "rating": 4.6,
      "reviews": 10757,
      "store": "Amazon",
      "title": "Caribou Coffee, Medium Roast Ground Coffee - Caribou Blend 20 Ounce Bag - Packaging May Vary",
      "unit": "oz",
      "unit_price": 0.6559999999999999,
      "amazon_price": 11.99,
      "walmart_price": 13.98
    },
    {
      "asin": "B00PQKRVFG",
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "d61a5d948e224d928d6e91cf94eb2ca9",
      "image": "https://m.media-amazon.com/images/I/61-amoVHDIL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B00PQKRVFG",
      "link": "https://www.amazon.com/Lavazza-Dolcevita-Classico-Full-bodied-Intensity/dp/B00PQKRVFG/",
      "price": 7.97,
      "rating": 4.5,
      "reviews": 7947,
      "store": "Amazon",
      "title": "Lavazza House Blend Perfetto Ground Coffee 12oz Bag, Medium Roast, Full-bodied, Intensity 3/5, 100% Arabica, Ideal for Drip Brewers, (Pack of 1) - Package May Vary",
      "unit": "oz",
      "unit_price": 0.6641666666666667
    },
    {
      "asin": "B00PQKRRXC",
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "d9f8708d053c496c94418518e4cfc7a2",
      "image": "https://m.media-amazon.com/images/I/613eoeq1eOL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B00PQKRRXC",
      "link": "https://www.amazon.com/Lavazza-Classico-Ground-Coffee-12-Ounce/dp/B00PQKRRXC/",
      "price": 7.97,
      "rating": 4.6,
      "reviews": 7734,
      "store": "Amazon",
      "title": "Lavazza Dolcevita Classico Ground Coffee 12oz Bag, Medium Roast, Rich and Full-bodied, Intensity 3/5, Arabica and Robusta, Ideal for Drip Brewers (Pack of 1) - Package May Vary",
      "unit": "oz",
      "unit_price": 0.6641666666666667
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "7d219ebefdf34f3e8f76f0f55cc31e9c",
      "image": "https://target.scene7.com/is/image/Target/GUEST_cf2ac40c-9e57-4778-a2f3-ffb3c48827da",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "78613365",
      "link": "https://www.target.com/p/donut-shop-blend-medium-roast-ground-coffee-12oz-good-38-gather-8482/-/A-78613365",
      "price": 7.99,
      "rating": 4.2,
      "reviews": 465,
      "store": "Target",
      "title": "Donut Shop Blend Medium Roast Ground Coffee - 12oz - Good &#38; Gather&#8482;",
      "unit": "oz",
      "unit_price": 0.6658333333333334
    },
    {
      "asin": "B07C1YFV6D",
      "capacity_per_item": 30,
      "capacity_per_pack": 30,
      "id": "9112c46071b7456da7ee015461ad31a2",
      "image": "https://m.media-amazon.com/images/I/81g3-Cms56L._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B07C1YFV6D",
      "link": "https://www.amazon.com/Dunkin-Donuts-Original-Ground-Canister/dp/B07C1YFV6D/",
      "price": 19.99,
      "rating": 4.8,
      "reviews": 8866,
      "store": "Amazon",
      "title": "Dunkin' Original Blend Medium Roast Ground Coffee, 30 Ounce",
      "unit": "oz",
      "unit_price": 0.6663333333333333
    },
    {
      "capacity_per_item": 9.6,
      "capacity_per_pack": 9.6,
      "id": "ba0ae362f2d54775baa3fbcafd8cbebd",
      "image": "https://i5.walmartimages.com/seo/Folgers-Classic-Roast-Ground-Coffee-Medium-Roast-9-6-oz-Canister_6bfd2db3-26cf-4fba-953a-cb44afe25503.b7ef549a72ab0dcd3ad41615c823f651.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "6QG67FCH72G4",
      "link": "https://www.walmart.com/ip/Folgers-Classic-Roast-Ground-Coffee-Medium-Roast-9-6-oz-Canister/241168688?classType=VARIANT&athbdg=L1600",
      "price": 6.53,
      "rating": 4.2,
      "reviews": 5313,
      "store": "Walmart",
      "title": "Folgers Classic Roast Ground Coffee, Medium Roast, 9.6 oz Canister",
      "unit": "oz",
      "unit_price": 0.6802083333333334
    },
    {
      "capacity_per_item": 22.6,
      "capacity_per_pack": 22.6,
      "id": "8171244fe8074fef8289f3a6332e0d0e",
      "image": "https://i5.walmartimages.com/seo/Folgers-Colombian-Ground-Coffee-Medium-Roast-22-6-Oz-Canister_1ee59f0b-50b1-458a-9bb1-17e9849d7086.08c28b51a3ae02e845b440d562a0525b.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "1BWT3Q472SSD",
      "link": "https://www.walmart.com/ip/Folgers-Colombian-Ground-Coffee-Medium-Roast-22-6-Oz-Canister/259484129?classType=VARIANT",
      "price": 15.86,
      "rating": 4.5,
      "reviews": 7080,
      "store": "Walmart",
      "title": "Folgers Colombian Ground Coffee, Medium Roast, 22.6 oz Canister",
      "unit": "oz",
      "unit_price": 0.7017699115044247
    },
    {
      "capacity_per_item": 11,
      "capacity_per_pack": 11,
      "id": "50d82867f50242c6a2b6c8ae9ab8173c",
      "image": "https://target.scene7.com/is/image/Target/GUEST_58cf12a8-3e9e-4c5c-abaf-9f4bcc0a0e06",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "50300469",
      "link": "https://www.target.com/p/caribou-vanilla-hazelnut-dreamstate-medium-roast-ground-coffee-11oz/-/A-50300469",
      "price": 7.99,
      "rating": 4.5,
      "reviews": 138,
      "store": "Target",
      "title": "Caribou Vanilla Hazelnut Dreamstate Medium Roast Ground Coffee - 11oz",
      "unit": "oz",
      "unit_price": 0.7263636363636364
    },
    {
      "asin": "B007PM9YLW",
      "capacity_per_item": 10,
      "capacity_per_pack": 10,
      "id": "49f014277d634e458cdc58c1f5827b15",
      "image": "https://m.media-amazon.com/images/I/71TDNfQzhQL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B007PM9YLW",
      "link": "https://www.amazon.com/Kauai-Coffee-Ground-Tropical-Bitterness/dp/B007PM9YLW/",
      "price": 7.49,
      "rating": 4.5,
      "reviews": 22370,
      "store": "Amazon",
      "title": "Kauai Coffee Ground Coffee \u2013 Smooth, Rich, Medium Roast \u2013 Nutty Caramel and Tropical Coconut \u2013 Arabica Coffee, 10% Hawaiian with No Bitterness \u2013 Coconut Caramel Crunch, 1 Pack of 10oz",
      "unit": "oz",
      "unit_price": 0.749
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "37a95b05739740408dfde191f8a2ca51",
      "image": "https://target.scene7.com/is/image/Target/GUEST_c2043fcf-3a8f-439f-9bd3-8dc39a2d2924",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "78613364",
      "link": "https://www.target.com/p/signature-coffee-organic-sumatra-mandheling-medium-roast-ground-coffee-12oz-good-38-gather-8482/-/A-78613364",
      "price": 8.99,
      "rating": 4.4,
      "reviews": 353,
      "store": "Target",
      "title": "Signature Coffee Organic Sumatra Mandheling Medium Roast Ground Coffee - 12oz - Good &#38; Gather&#8482;",
      "unit": "oz",
      "unit_price": 0.7491666666666666
    },
    {
      "asin": "B009HSNDI2",
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "679798566b674c209a96c606a0f9334c",
      "image": "https://m.media-amazon.com/images/I/81pMcWypUdL._AC_UL320_.jpg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "B009HSNDI2",
      "link": "https://www.amazon.com/Dunkin-Donuts-Original-Medium-Ground/dp/B009HSNDI2/",
      "price": 9.44,
      "rating": 4.6,
      "reviews": 42616,
      "store": "Amazon",
      "title": "Dunkin' Original Blend Medium Roast Ground Coffee, 12 Ounces",
      "unit": "oz",
      "unit_price": 0.7866666666666666
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "42cc53bc114d4751bf4f100ad25f04e2",
      "image": "https://i5.walmartimages.com/seo/Dunkin-Original-Blend-Ground-Coffee-Medium-Roast-12-Oz-Bag_ff3fdce2-8f07-485a-bc44-a61da568714d.19b156e6dbe465fa30669acab17ca538.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "6N1FPADGFP9C",
      "link": "https://www.walmart.com/ip/Dunkin-Original-Blend-Ground-Coffee-Medium-Roast-12-Oz-Bag/10448644?classType=VARIANT&athbdg=L1600",
      "price": 10.62,
      "rating": 4.5,
      "reviews": 5193,
      "store": "Walmart",
      "title": "Dunkin Original Blend Ground Coffee, Medium Roast, 12 Oz Bag",
      "unit": "oz",
      "unit_price": 0.8849999999999999
    },
    {
      "capacity_per_item": 12,
      "capacity_per_pack": 12,
      "id": "1c28582824164b58a8a4b6a4dafb627d",
      "image": "https://target.scene7.com/is/image/Target/GUEST_03c38f00-92fe-4a41-ac74-be2de6d891b8",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "12954088",
      "link": "https://www.target.com/p/starbucks-medium-roast-ground-coffee-8212-house-blend-8212-100-arabica-8212-1-bag-12-oz/-/A-12954088",
      "price": 10.79,
      "rating": 4.6,
      "reviews": 829,
      "store": "Target",
      "title": "Starbucks House Blend Medium Roast Ground Coffee - 12oz",
      "unit": "oz",
      "unit_price": 0.8991666666666666
    },
    {
      "capacity_per_item": 11,
      "capacity_per_pack": 11,
      "id": "d03bde66265141b3985fe926cb6e6156",
      "image": "https://target.scene7.com/is/image/Target/GUEST_497a45dd-daed-4cd8-9de6-71b8d6b85e75",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "94622230",
      "link": "https://www.target.com/p/dunkin-39-donuts-apple-cider-donut-flavored-medium-roast-ground-coffee-11oz/-/A-94622230",
      "price": 9.99,
      "rating": 4.6,
      "reviews": 247,
      "store": "Target",
      "title": "Dunkin&#39; Donuts Apple Cider Donut Flavored Medium Roast Ground Coffee - 11oz",
      "unit": "oz",
      "unit_price": 0.9081818181818182
    },
    {
      "capacity_per_item": 11,
      "capacity_per_pack": 11,
      "id": "1dc4c253ea0943a7a7748081fbcf4fd1",
      "image": "https://target.scene7.com/is/image/Target/GUEST_c2c7e7cb-626c-4e45-83b7-5ac79d0ea7a5",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "14337016",
      "link": "https://www.target.com/p/dunkin-donuts-pumpkin-spice-medium-roast-ground-coffee-11oz/-/A-14337016",
      "price": 9.99,
      "rating": 4.5,
      "reviews": 761,
      "store": "Target",
      "title": "Dunkin&#39; Pumpkin Spice Flavored Medium Roast Ground Coffee - 11oz",
      "unit": "oz",
      "unit_price": 0.9081818181818182
    },
    {
      "capacity_per_item": 11,
      "capacity_per_pack": 11,
      "id": "ed622929a6934988850ab7c963c4c008",
      "image": "https://i5.walmartimages.com/seo/Dunkin-Colombian-Medium-Roast-Ground-Coffee-11-oz-Bag_4e893baa-20f4-434f-a058-4a11503f7863.eb03dc10339adb9b8ccb2afb9492c2ec.jpeg",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "4KT3O8SZF96P",
      "link": "https://www.walmart.com/ip/Dunkin-Colombian-Medium-Roast-Ground-Coffee-11-oz-Bag/40515321?classType=VARIANT",
      "price": 10.62,
      "rating": 4.5,
      "reviews": 5193,
      "store": "Walmart",
      "title": "Dunkin Colombian Medium Roast Ground Coffee, 11 oz Bag",
      "unit": "oz",
      "unit_price": 0.9654545454545453
    },
    {
      "capacity_per_item": 11,
      "capacity_per_pack": 11,
      "id": "61814e20ada34d2094ee22b63e602de6",
      "image": "https://target.scene7.com/is/image/Target/GUEST_ee2692d8-1cbc-4f9f-baa6-23156e3ad45b",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "90343019",
      "link": "https://www.target.com/p/starbucks-smoked-butterscotch-ground-coffee-11oz/-/A-90343019",
      "price": 10.79,
      "rating": 4.3,
      "reviews": 172,
      "store": "Target",
      "title": "Starbucks Smoked Butterscotch Medium Roast Ground Coffee - 11oz",
      "unit": "oz",
      "unit_price": 0.9809090909090908
    },
    {
      "capacity_per_item": 10,
      "capacity_per_pack": 10,
      "id": "fa2bd7653e794a1685485a02f4bd67cf",
      "image": "https://target.scene7.com/is/image/Target/GUEST_0be7fb2a-6415-4b07-be41-91a749df8849",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "86517226",
      "link": "https://www.target.com/p/don-francisco-39-s-kona-blend-medium-roast-ground-coffee-10oz/-/A-86517226",
      "price": 9.99,
      "rating": 4.6,
      "reviews": 221,
      "store": "Target",
      "title": "Don Francisco&#39;s Kona Blend Medium Roast Ground Coffee - 10oz",
      "unit": "oz",
      "unit_price": 0.999
    },
    {
      "capacity_per_item": 10,
      "capacity_per_pack": 10,
      "id": "c00eea83510949828503107963a6c53f",
      "image": "https://target.scene7.com/is/image/Target/GUEST_b675095d-7bc5-4950-9cd7-b4a92d537b0d",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "88498117",
      "link": "https://www.target.com/p/death-wish-coffee-medium-roast-ground-coffee-10oz/-/A-88498117",
      "price": 11.49,
      "rating": 4.7,
      "reviews": 1069,
      "store": "Target",
      "title": "Death Wish Coffee Organic and Fair Trade Medium Roast Ground Coffee 10oz",
      "unit": "oz",
      "unit_price": 1.149
    },
    {
      "capacity_per_item": 8.8,
      "capacity_per_pack": 8.8,
      "id": "593b52049e7b4b2bad6cac2970033087",
      "image": "https://i5.walmartimages.com/seo/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz_1fc800ea-be2b-45a7-b47b-6828c4f0211b.c9279e6f6b764c2329e772884d7ec174.jpeg?odnHeight=180&odnWidth=180&odnBg=FFFFFF",
      "is_large_size": false,
      "items_per_pack": 1,
      "key": "5KCG1SWNBSO7",
      "link": "https://www.walmart.com/ip/illy-Ground-Coffee-Drip-Classico-Medium-Roast-8-8-oz/30999456?classType=REGULAR",
      "price": 15.53,
      "rating": 4.8,
      "reviews": 479,
      "store": "Walmart",
      "title": "illy Ground Drip Coffee, Classico Medium Roast, 100% Arabica, 8.8 oz",
      "unit": "oz",
      "unit_price": 1.7647727272727272
    }
  ]
}) {

  const rowRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    if (!rowRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = rowRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  useEffect(() => {
    checkScroll();
    const el = rowRef.current;
    if (!el) return;

    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [products]);

  const scrollLeft = () => {
    rowRef.current?.scrollBy({ left: -300, behavior: "smooth" }); // scroll 300px left
  };

  const scrollRight = () => {
    rowRef.current?.scrollBy({ left: 300, behavior: "smooth" }); // scroll 300px right
  };
  if (!products || products?.length === 0) {
    return null; // skip section if no products
  }

  return (
    <div style={{ marginBottom: "1rem" }}>
      {/* Section Header */}
      <UIRecommendationHeaderNew
        iconType={iconType}
        title={title}
        subtitle={subtitle}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
      />

      {/* Products Row */}
      <section className="product-row">
        <Row
          gutter={[16, 16]}
          ref={rowRef}
          className="product-row-inner"
        >
          {products?.length && products.map((p) => (
            <Col
              className="product-col"
              key={p.id}
              xs={24} md={24} lg={24}
            >
              <ProductCardNew {...p} buttonColor={backgroundColor} fontColor={fontColor} />
            </Col>
          ))}
        </Row>


        {canScrollLeft && (<Button  onClick={scrollLeft} className="pd-slide-btn-left" shape="circle" icon={<LeftOutlined />} />)}
        {canScrollRight && (<Button onClick={scrollRight} className="pd-slide-btn-right" shape="circle" icon={<RightOutlined />} />)}
      </section>
    </div>
  );
}